import React from 'react';
import {
  EmptyState, EmptyStateContent, EmptyStateSize, EmptyStateSurfaceIcon,
} from '@bingads-webui-fluent-component/empty-state';
import { LocationIcon } from './location-icon';

const NoResultsMessage = ({ title, subtext }: { title: string, subtext: string }) => (
  <EmptyState size={EmptyStateSize.mediumSurface}>
    <EmptyStateContent
      title={title}
      subtext={subtext}
    >
      <EmptyStateSurfaceIcon icon={<LocationIcon />} />
    </EmptyStateContent>
  </EmptyState>
);

export default NoResultsMessage;
